export class CorpException {
    // Infos techniques
  public readonly technicalMessage?: string;
  public readonly stack?: string;
  public readonly statusCode?: number;
  public readonly originalError?: any;

  // Infos utilisateur
  public readonly userMessage: string;
  public readonly userCode?: string;

  constructor(params: {
    userMessage: string;
    userCode?: string;
    technicalMessage?: string;
    statusCode?: number;
    stack?: string;
    originalError?: any;
  }) {
    this.userMessage = params.userMessage;
    this.userCode = params.userCode;
    this.technicalMessage = params.technicalMessage;
    this.statusCode = params.statusCode;
    this.stack = params.stack;
    this.originalError = params.originalError;
  }
}